import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { InvestmentPlanTemporaryTargetAllocationResponseDTO } from '@backend/dto';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class TemporaryInvestmentPlanTargetAllocationRequest extends Request<
  never,
  InvestmentPlanTemporaryTargetAllocationResponseDTO
> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      path: `/broad${options?.version ?? '/v1'}/me/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/target_allocation`
    });
  }

  public execute(): Observable<InvestmentPlanTemporaryTargetAllocationResponseDTO> {
    return super
      .execute()
      .pipe(
        map(
          (response: HttpResponse<InvestmentPlanTemporaryTargetAllocationResponseDTO>) =>
            response.body
        )
      );
  }
}

export function getTemporaryInvestmentPlanTargetAllocation(
  options?: RequestOptions<never>
): TemporaryInvestmentPlanTargetAllocationRequest {
  return new TemporaryInvestmentPlanTargetAllocationRequest(options);
}
